module.exports = __webpack_public_path__ + "img/93971.a3369a0a.svg";